import createApiClient from "../lib/createApiClient";
import { apiUrl } from "../config";

const api = createApiClient(apiUrl + "/api/banner");

export default api;
